import React, { useEffect } from 'react';
import { FDStack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useLayoutContext } from 'Context/LayoutContext';
import {
  PlannerInsightChatLayout,
} from '../PlannerInsightChat/layout';
import PlannerInsightChatMetaOverrideSet
  from '../PlannerInsightChat/metaOverrideSet';
import { RoadmapDeliverableWrapperLayout } from '../Wrapper/RoadmapDeliverableWrapperLayout';
import { Content } from './Content';

const RoadmapDeliverableLayout = () => {
  const { resource } = useMetaLayoutContext();
  const { setNavigationVisible } = useLayoutContext();
  const PlannerInsightChat = (
    <MetaResourceRenderer
      resource={resource} // has attrs for cfp insight
      layout={PlannerInsightChatLayout}
      metaOverrideSet={PlannerInsightChatMetaOverrideSet}
    />
  );

  useEffect(() => {
    setNavigationVisible(false);
  }, [setNavigationVisible]);

  return (
    <RoadmapDeliverableWrapperLayout>
      <FDStack direction="column" spacing={5} width={'100%'} maxWidth={600}>
        {PlannerInsightChat}
        <Content />
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default RoadmapDeliverableLayout;
